<template>
    <a-modal v-model="visible" :title="title" centered :maskClosable="false" :keyboard="false">
        <a-form class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-row :gutter="[0, 6]">
                <a-col :span="24">
                    <a-form-item label="用户名" v-if="needChangePwd" required>
                        <a-input ref="username" v-model="username" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="旧密码">
                        <a-input ref="old_password" type="password" v-model="editData.old_password" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="新密码" required>
                        <a-input ref="new_password" type="password" v-model="editData.new_password" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="确认密码" required>
                        <a-input ref="check_password" type="password" v-model="editData.check_password" />
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "ChangeInfo",
    props: ["showEdit", "needChangePwd", "inputUserName"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: { old_password: "" },
            editDataLoading: false
        };
    },
    computed: {
        title() {
            return this.needChangePwd ? "您的密码安全等级过低，请先修改密码!" : "修改密码";
        },
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        username() {
            return this.inputUserName;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 设置光标位置
                    this.$nextTick(() => {
                        this.$refs.old_password.focus();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        // 取消
        onClose(e) {
            this.visible = false;
        },
        //提交form
        onSave() {
            if (!this.username && this.needChangePwd) {
                this.$FG_message.error("用户名必输").then(() => this.$refs.new_password.focus());
                return;
            }
            this.editData.username = this.username;
            if (!this.editData.new_password) {
                this.$FG_message.error("新密码必输").then(() => this.$refs.new_password.focus());
                return;
            }
            if (!this.editData.check_password) {
                this.$FG_message.error("确认密码必输").then(() => this.$refs.check_password.focus());
                return;
            }
            if (this.editData.new_password !== this.editData.check_password) {
                this.$FG_message.error("两次密码输入不一致，请检查!").then(() => this.$refs.check_password.focus());
                return;
            }
            // 保存操作
            this.$FG_message.confirm("确认保存?").then((type) => {
                if (type === "ok") {
                    this.saving = true;
                    this.$FG_http
                        .post("./api/admin/user/changeInfo", {
                            jsonData: [this.editData]
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 返回列表
                                this.visible = false;
                            } else {
                                this.$refs.old_password.focus();
                            }
                        });
                }
            });
        }
    }
};
</script>
